<template>
  <div class="userWeighting">
    <el-card class="box-card">
      <div class="item">
        用户ID:
        <el-input class="item-input" placeholder="请输入内容" v-model="userId">
          <el-button slot="append" @click="searchWeightingInfo">查询</el-button>
        </el-input>
      </div>
      <div class="item">
        昵称:
        <span v-text="userWeightingInfo.nickName"></span>
      </div>
      <div class="item">
        加权状态:
        <span v-if="userWeightingInfo.weightingStatus == 0">未加权</span>
        <span v-else-if="userWeightingInfo.weightingStatus == 1">永久注销加权</span>
        <span v-else-if="userWeightingInfo.weightingStatus == 2">新用户加权</span>
        <span v-else-if="userWeightingInfo.weightingStatus == 3">浅水加权</span>
        <span v-else-if="userWeightingInfo.weightingStatus == 4">深水加权</span>
        <span v-else-if="userWeightingInfo.weightingStatus == 5">回归加权</span>
        <span v-else-if="userWeightingInfo.weightingStatus == 6">手工加权</span>
      </div>
      <div class="card-item" v-show="weihtingShow">
        <el-card class="box-card">
          <p style="color: #3f51b5">手动加权</p>
          <div class="bc-item">
            加权期限
            <el-input
              class="bc-item-input"
              v-model="weightingDate"
              placeholder="请输入加权期限（3-7）"
              >天</el-input
            >
            <el-select
              v-model="limitPl"
              style="margin-right: 22px"
              placeholder="请选择加权记分牌限额"
            >
              <el-option
                v-for="item in integralOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button type="primary" @click="setWeightingOk">确认加权</el-button>
          </div>
        </el-card>
      </div>
      <div class="card-item" v-show="cancelWeihtingShow">
        <el-card class="box-card">
          <p style="color: #3f51b5">取消加权</p>
          <el-radio v-model="weightingType" label="1">永久注销加权</el-radio>
          <el-radio v-model="weightingType" label="0">取消当前加权</el-radio>
          <el-button type="primary" @click="cancelWeightingNo">确认取消</el-button>
        </el-card>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    // compClubConfig
  },
  data() {
    return {
      loading: false,
      userId: '',
      weightingType: '0', //取消加权类型
      weightingDate: '', //加权期限
      weihtingShow: false,
      cancelWeihtingShow: false,
      integralOptions: [
        {
          label: '默认',
          value: '-1',
        },
        {
          label: '1000',
          value: '1000',
        },
        {
          label: '2000',
          value: '2000',
        },
        {
          label: '3000',
          value: '3000',
        },
        {
          label: '4000',
          value: '4000',
        },
        {
          label: '5000',
          value: '5000',
        },
        {
          label: '6000',
          value: '6000',
        },
        {
          label: '7000',
          value: '7000',
        },
        {
          label: '8000',
          value: '8000',
        },
        {
          label: '9000',
          value: '9000',
        },
        {
          label: '10000',
          value: '10000',
        },
      ],
      limitPl: '-1',
    };
  },
  computed: {
    ...mapState('user', ['userWeightingInfo']),
    userType() {
      return localStorage.getItem('authTypeCode');
    },
  },
  created() {},
  methods: {
    ...mapActions('user', ['getUserWeightingInfo', 'setWeighting', 'cancelWeighting']),
    // 加权数据统计列表
    searchWeightingInfo() {
      this.loading = true;
      this.getUserWeightingInfo(this.userId).then(() => {
        this.loading = false;
        if (
          this.userWeightingInfo.weightingStatus == '0' ||
          this.userWeightingInfo.weightingStatus == '1'
        ) {
          this.weihtingShow = true;
          this.cancelWeihtingShow = false;
        } else if (
          this.userWeightingInfo.weightingStatus != '0' &&
          this.userWeightingInfo.weightingStatus != '1'
        ) {
          this.cancelWeihtingShow = true;
          this.weihtingShow = false;
        }
      });
    },
    setWeightingOk() {
      if (this.weightingDate < 3 || this.weightingDate > 7) {
        this.$message.error('请输入3～7');
        return;
      }
      let params = {
        dayNum: this.weightingDate,
        userId: this.userWeightingInfo.userHid,
        limitPl: this.limitPl,
      };
      this.setWeighting(params).then(() => {
        this.searchWeightingInfo();
        this.$message.success('设置成功');
      });
    },
    cancelWeightingNo() {
      let params = {
        type: this.weightingType,
        userId: this.userWeightingInfo.userHid,
      };
      this.cancelWeighting(params).then(() => {
        this.searchWeightingInfo();
        this.$message.success('设置成功');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.userWeighting {
  .box-card {
    .item {
      padding: 20px;
      .item-input {
        width: 300px;
      }
    }
    .card-item {
      padding: 20px;
      .box-card {
        .bc-item {
          padding: 15px 0;
          .bc-item-input {
            width: 180px;
            margin-right: 27px;
          }
        }
      }
    }
  }
}
:global(.el-icon-edit-outline) {
  color: $theme-color;
  cursor: pointer;
}
</style>
